module.exports = __webpack_public_path__ + "img/img_intro_3_1.adca727b.png";